/**
 * Click-drag horizontal scroll for Media cards.
 * Use with draggable="false" on images/links (see card-media.liquid).
 */
(function () {
  const DRAG_THRESHOLD_PX = 6;

  function initSliderDrag(slider) {
    if (slider.dataset.mediaCardsDragInit === 'true') return;
    slider.dataset.mediaCardsDragInit = 'true';

    let active = false;
    let captureId = null;
    let startClientX = 0;
    let startScrollLeft = 0;
    let didDrag = false;

    function isChromeOfControls(el) {
      return el.closest('.slider-buttons, [data-media-cards-dots], .media-cards__dots-root');
    }

    function releaseCapture() {
      if (captureId == null) return;
      try {
        slider.releasePointerCapture(captureId);
      } catch (_) {}
      captureId = null;
    }

    slider.addEventListener(
      'dragstart',
      function (e) {
        e.preventDefault();
      },
      true
    );

    slider.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (isChromeOfControls(e.target)) return;

        active = true;
        didDrag = false;
        startClientX = e.clientX;
        startScrollLeft = slider.scrollLeft;
        captureId = e.pointerId;

        slider.classList.add('media-cards__slider--dragging');

        try {
          slider.setPointerCapture(e.pointerId);
        } catch (_) {}
      },
      { passive: true }
    );

    slider.addEventListener(
      'pointermove',
      function (e) {
        if (!active) return;
        const dx = e.clientX - startClientX;
        if (Math.abs(dx) > DRAG_THRESHOLD_PX) {
          didDrag = true;
        }
        slider.scrollLeft = startScrollLeft - dx;
        if (didDrag) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    function endDrag() {
      if (!active) return;
      active = false;
      releaseCapture();
      slider.classList.remove('media-cards__slider--dragging');
    }

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('lostpointercapture', endDrag);

    slider.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('.media-cards [id^="Slider-"].slider').forEach(initSliderDrag);
  }

  function onSectionLoad(event) {
    const root = event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.media-cards [id^="Slider-"].slider').forEach(function (slider) {
      delete slider.dataset.mediaCardsDragInit;
      initSliderDrag(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
